import { LegalNotice } from '../../components/legal-notice/LegalNotice';
import React from 'react';

/**
 * View responsible for providing the Legal Notice view component
 */
export const LegalNoticePage: React.FC = () => <LegalNotice />;
